'use client';

import { useState } from 'react';
import __ from './../utils/translation';
import $ from "jquery";
import { Tab } from './Tabs';
import { ChromePicker } from 'react-color';
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Slider } from "./ui/slider";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Tabs as ShadcnTabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Badge } from "./ui/badge";
import { Palette, Layers, Sparkles, CircleDot, Eye, ImageIcon, RefreshCw, Plus, Save, Trash2 } from "lucide-react";
// Fabric texture placeholder URLs
const IconColth1 = "./cloth_fabric/thumbs/1.jpg";
const IconColth2 = "./cloth_fabric/thumbs/2.png";
const IconColth3 = "./cloth_fabric/thumbs/3.png";
const IconColth4 = "./cloth_fabric/thumbs/4.png";
const IconColth5 = "./cloth_fabric/thumbs/5.png";
const IconColth6 = "./cloth_fabric/thumbs/6.png";
const IconColth7 = "./cloth_fabric/thumbs/7.png";
const IconColth8 = "./cloth_fabric/thumbs/8.png";
const IconColth9 = "./cloth_fabric/thumbs/9.png";
const IconColth10 = "./cloth_fabric/thumbs/10.png";
const IconColth11 = "./cloth_fabric/thumbs/11.png";
const IconColth12 = "./cloth_fabric/thumbs/12.png";
const IconColth13 = "./cloth_fabric/thumbs/13.png";
const IconColth14 = "./cloth_fabric/thumbs/14.webp";
const IconColth15 = "./cloth_fabric/thumbs/15.webp";

const IconActiveLife = "./cloth_fabric/falcon/active-life/active-life.webp";
const IconEco = "./cloth_fabric/falcon/eco/eco.webp";
const IconJacquard = "./cloth_fabric/falcon/jacquard/jacquard.webp";
const IconLumiTech = "./cloth_fabric/falcon/lumi-tech/lumi-tech.webp";
const IconTelas = "./cloth_fabric/falcon/telas/telas.webp";

const IconActiveLife1 = "./cloth_fabric/falcon/active-life/thumbs/FC_202_MICRO_DRY.jpg";
const IconActiveLife2 = "./cloth_fabric/falcon/active-life/thumbs/FC_203_Micro_Dry_Euro.png";
const IconActiveLife3 = "./cloth_fabric/falcon/active-life/thumbs/FC_205_Ribana.jpg";
const IconActiveLife4 = "./cloth_fabric/falcon/active-life/thumbs/FC_211_Villa_Real.jpg";
const IconActiveLife5 = "./cloth_fabric/falcon/active-life/thumbs/FC_240_Confort_Skin_UV_FPS_50+.jpg";
const IconActiveLife6 = "./cloth_fabric/falcon/active-life/thumbs/FC_245_Thermo_Dry.jpg";
const IconActiveLife7 = "./cloth_fabric/falcon/active-life/thumbs/FC_252_FAVO_DRY.jpg";

const Cloth = ({ }) => {

    const [drawSettings, setDrawSettings] = useState({
        duration: 1, time: 10, brilho: 0, metal: 0, scale: 0, color: 'rgba(255, 255, 255, 0)', camisa: true, short: true,
        meia: true, corpo: false, sapato: true, cabelo: true, mascara: true, oculos: true, hats: true, fone: true,
        polchete: true, morph: true, map: null, opacity: 100
    })

    const handleBrilhoChange = (value: any) => {
        setDrawSettings({ ...drawSettings, brilho: value });
        (window as any)['updateRoughness'](value);
    }

    const handleMetalChange = (value: any) => {
        setDrawSettings({ ...drawSettings, metal: value });
        (window as any)['updateMetalness'](value);
    }

    const handleOpacityChange = (value: any) => {
        setDrawSettings({ ...drawSettings, opacity: value });
        (window as any)['updateOpacity'](value);
    }

    const handleMapChange = (value: any) => {
        var fileName = URL.createObjectURL(value.files[0]);
        (window as any)['updateMap'](fileName);
        $("#map-mesh").val('');
    }

    const handleColorChange = (color: any) => {
        setDrawSettings({ ...drawSettings, color: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})` });
        (window as any)['updateColorMaterial'](color);
    }

    (window as any)['colorMesh'] = function (color: any, metal: any, brilho: any) {
        setDrawSettings({ ...drawSettings, color: `rgba(${color.r * 255}, ${color.g * 255}, ${color.b * 255}, 1)`, metal: metal, brilho: brilho })
    }

    return (
        <Card className="w-full shadow-xl bg-card/85 backdrop-blur-sm border-none p-2 rounded-lg">
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-lg font-semibold tracking-tight lang" data-en="CUSTOMIZE MATERIALS" data-pt="PERSONALIZAR MATERIAIS" data-es="PERSONALIZAR MATERIALES">
                    <Sparkles className="h-5 w-5 text-primary" />
                    {__('CUSTOMIZE MATERIALS')}
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                <ShadcnTabs defaultValue="material" className="w-full">
                    <TabsList className="grid w-full grid-cols-2 mb-4 hidden">
                        <TabsTrigger
                            value="material"
                            id="custom-material"
                            data-type="material"
                            data-display="block"
                            className="custom-type flex items-center gap-2"
                        >
                            <Palette className="h-4 w-4" />
                            {__('Material')}
                        </TabsTrigger>
                        <TabsTrigger
                            value="fabric"
                            id="custom-parts"
                            data-type="fabric-options-parent"
                            data-display="block"
                            className="custom-type lang flex items-center gap-2"
                            data-en="Fabric"
                            data-pt="Tecido"
                            data-es="Tela"
                        >
                            <Layers className="h-4 w-4" />
                            {__('Fabric')}
                        </TabsTrigger>
                    </TabsList>

                    <div className='flex'>
                        <label id="cloth-material-btn" className='w-[50%] text-center p-2 bg-background cursor-pointer hover:bg-[green]'>Material</label>
                        <label id="cloth-fabric-btn" className='w-[50%] text-center p-2 cursor-pointer hover:bg-[green]'>Tecido</label>
                    </div>

                    {/* Options Panel */}
                    <div className="block-panel options space-y-0 mb-0" id="mat-colors">
                        <div className="p-3 rounded-lg bg-muted/50 border space-y-2">
                            <p className='text-xs text-muted-foreground lang' data-en="To edit the material, double click on the part you want to select" data-pt="Para editar o material, clique duas vezes na peça que deseja selecionar" data-es="Para editar el material, haga doble clic en la parte que desea seleccionar">
                                To edit the material, double click on the part you want to select
                            </p>
                            <Badge variant="outline" id="object-name" className="text-xs">...</Badge>
                        </div>
                    </div>

                    <TabsContent value="material" id="" className='custom space-y-4'>

                        <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50 border">
                            <Label htmlFor="inside-color" className="text-sm font-medium">Cor Interna</Label>
                            <Input type='color' id="inside-color" className="w-12 h-8 p-1 cursor-pointer rounded-md border-2 hover:border-primary transition-colors" />
                        </div>

                        <div id="cloth-material">
                            <div className='thumb-background-color material rounded-lg overflow-hidden border' id="color-mesh">
                                <Tab title={__('Color fill')} name="color">
                                    <ChromePicker color={drawSettings.color} onChange={handleColorChange} />
                                </Tab>
                            </div>

                            <div className="space-y-4 p-4 rounded-lg bg-muted/30 border">
                                <div className="setting material space-y-2">
                                    <div className="flex items-center justify-between">
                                        <Label className="flex items-center gap-2 text-sm font-medium lang" data-en="Shininess" data-pt="Brilho" data-es="Brillo">
                                            <Sparkles className="h-4 w-4 text-amber-500" />
                                            {__('Shininess')}
                                        </Label>
                                        <span className="text-xs text-muted-foreground font-mono">{drawSettings.brilho}%</span>
                                    </div>
                                    <Slider
                                        id="brilho-mesh"
                                        min={0}
                                        max={100}
                                        step={1}
                                        onValueChange={(value) => handleBrilhoChange(value[0])}
                                        value={[drawSettings.brilho]}
                                        className="w-full"
                                    />
                                </div>

                                <div className="setting material space-y-2">
                                    <div className="flex items-center justify-between">
                                        <Label className="flex items-center gap-2 text-sm font-medium lang" data-en="Metalness" data-pt="Metalidade" data-es="metalidad">
                                            <CircleDot className="h-4 w-4 text-slate-400" />
                                            {__('Metalness')}
                                        </Label>
                                        <span className="text-xs text-muted-foreground font-mono">{drawSettings.metal}%</span>
                                    </div>
                                    <Slider
                                        id="metal-mesh"
                                        min={0}
                                        max={100}
                                        step={1}
                                        onValueChange={(value) => handleMetalChange(value[0])}
                                        value={[drawSettings.metal]}
                                        className="w-full"
                                    />
                                </div>

                                <div className="setting material space-y-2">
                                    <div className="flex items-center justify-between">
                                        <Label className="flex items-center gap-2 text-sm font-medium">
                                            <Eye className="h-4 w-4 text-blue-500" />
                                            {__('Transparência')}
                                        </Label>
                                        <span className="text-xs text-muted-foreground font-mono">{drawSettings.opacity}%</span>
                                    </div>
                                    <Slider
                                        id="opacidade-mesh"
                                        min={0}
                                        max={100}
                                        step={1}
                                        onValueChange={(value) => handleOpacityChange(value[0])}
                                        value={[drawSettings.opacity]}
                                        className="w-full"
                                    />
                                </div>

                                <div className="setting material space-y-2">
                                    <Label className="flex items-center gap-2 text-sm font-medium lang" data-en="Custom Map" data-pt="Mapa personalizado" data-es="Mapa personalizado">
                                        <ImageIcon className="h-4 w-4 text-green-500" />
                                        {__('Custom Map')}
                                    </Label>
                                    <Input
                                        id="map-mesh"
                                        type="file"
                                        accept='.jpg'
                                        onChange={(e) => handleMapChange(e.target)}
                                        className="cursor-pointer file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-xs file:font-semibold file:bg-primary file:text-primary-foreground hover:file:bg-primary/90"
                                    />
                                </div>
                            </div>
                        </div>

                        <div id="cloth-fabric" className='hidden'>

                            <Button id="add-fabric" variant="default" size="sm" className='flex items-center gap-2 w-full mb-2'>
                                <Plus className="h-4 w-4" />
                                Cadastrar Tecido
                            </Button>

                            <div className='flex items-center gap-3 p-3 rounded-lg bg-muted/50 border flex-col'>
                                <span className='text-justify'>Ajustar a escala do tecido. Teste valores de 1 a 1000 para verificar o que fica mais adequado.</span>
                                <div className='flex items-center gap-3' >
                                    <Label className="text-sm font-medium whitespace-nowrap">Escala:</Label>
                                    <Input
                                        step={1}
                                        min={1}
                                        max={1000}
                                        id="input-repeat-fabric"
                                        type="number"
                                        defaultValue={100}
                                        className="w-20 h-8"
                                    />
                                    <Button id="update-fabric" variant="secondary" size="sm" className="flex items-center gap-2">
                                        <RefreshCw className="h-3 w-3" />
                                        Update
                                    </Button>
                                </div>
                            </div>

                            <Button
                                id="save-fabric-preset"
                                variant="outline"
                                size="sm"
                                className='flex items-center gap-2 w-full mt-2'
                                onClick={() => (window as any)["saveFabricPreset"]?.()}
                            >
                                <Save className="h-4 w-4" />
                                Salvar Preset do Tecido
                            </Button>

                            <Button
                                id="remove-all-fabrics"
                                variant="outline"
                                size="sm"
                                className='flex items-center gap-2 w-full mt-1 border-destructive/40 text-destructive hover:bg-destructive/10'
                                onClick={() => (window as any)["removeAllFabrics"]?.()}
                            >
                                <Trash2 className="h-4 w-4" />
                                Remover Todos os Tecidos
                            </Button>

                            <div id="fabric-options" className="rounded-lg border bg-muted/20 p-3 overflow-y-auto mt-2">
                                <div className='grid grid-cols-2 gap-10 place-items-center' id="tecido">

                                    {/**<div className='w-[100px] h-[100px] relative cursor-pointer'>
                                        <div className='bg-cover w-full h-full rounded-lg bg-[green]'></div>
                                        <span className='bottom-[-20px] absolute w-full text-center uppercase'>Simulador</span>
                                    </div>

                                    <div className='w-[100px] h-[100px] relative cursor-pointer'>
                                        <div
                                            className='bg-cover w-full h-full rounded-lg'
                                            style={{ backgroundImage: "url(" + IconActiveLife + ")" }}>
                                        </div>
                                        <span className='bottom-[-20px] absolute w-full text-center uppercase'>Active Life</span>
                                    </div>
                                    <div className='w-[100px] h-[100px] relative cursor-pointer'>
                                        <div
                                            className='bg-cover w-full h-full rounded-lg'
                                            style={{ backgroundImage: "url(" + IconEco + ")" }}>
                                        </div>
                                        <span className='bottom-[-20px] absolute w-full text-center uppercase'>Eco</span>
                                    </div>
                                    <div className='w-[100px] h-[100px] relative cursor-pointer'>
                                        <div
                                            className='bg-cover w-full h-full rounded-lg'
                                            style={{ backgroundImage: "url(" + IconJacquard + ")" }}>
                                        </div>
                                        <span className='bottom-[-20px] absolute w-full text-center uppercase'>Jacquard</span>
                                    </div>
                                    <div className='w-[100px] h-[100px] relative cursor-pointer'>
                                        <div
                                            className='bg-cover w-full h-full rounded-lg'
                                            style={{ backgroundImage: "url(" + IconLumiTech + ")" }}>
                                        </div>
                                        <span className='bottom-[-20px] absolute w-full text-center uppercase'>LUMI TECH</span>
                                    </div>
                                    <div className='w-[100px] h-[100px] relative cursor-pointer hover:border-primary'>
                                        <div
                                            className='bg-cover w-full h-full rounded-lg '
                                            style={{ backgroundImage: "url(" + IconTelas + ")" }}>
                                        </div>
                                        <span className='bottom-[-20px] absolute w-full text-center uppercase'>Telas</span>
                                    </div> */}

                                    {/**Active Life
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_202_MICRO_DRY-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconActiveLife1 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_202_MICRO_DRY">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 202 MICRO DRY</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_203_Micro_Dry_Euro-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconActiveLife2 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_203_Micro_Dry_Euro">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 203 Micro Dry Euro</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_205_Ribana-normal.jpg"
                                        data-repeat="100"
                                        style={{ backgroundImage: "url(" + IconActiveLife3 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_205_Ribana">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 205 Ribana</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_211_Villa_Real-normal.jpg"
                                        data-repeat="100"
                                        style={{ backgroundImage: "url(" + IconActiveLife4 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_211_Villa_Real">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 211 Villa Real</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_240_Confort_Skin_UV_FPS_50+-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconActiveLife5 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_240_Confort_Skin_UV_FPS_50+">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 240 Confort Skin UV FPS 50+</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_245_Thermo_Dry-normal.jpg"
                                        data-repeat="150"
                                        style={{ backgroundImage: "url(" + IconActiveLife6 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_245_Thermo_Dry">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 245 Thermo Dry</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        data-path="/cloth_fabric/falcon/active-life/normal/FC_252_FAVO_DRY-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconActiveLife7 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="falcon/active-life/normal/FC_252_FAVO_DRY">
                                        <span className='bottom-[-35px] absolute w-full text-center h-[30px]'>FC 252 FAVO DRY</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div> */}


                                    {/**SIMULADOR */}
                                    {/**<div
                                        data-path="/cloth_fabric/1-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconColth1 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="1">
                                        <span className='bottom-[-20px] absolute w-full text-center'>1</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div> */}
                                    <div
                                        id="tecido-0"
                                        data-path="null"
                                        data-repeat="400"
                                        style={{ backgroundImage: "url()" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="2">
                                        <span className='bottom-[-20px] absolute w-full text-center'>Null</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-1"
                                        data-path="/cloth_fabric/2-normal.jpg"
                                        data-repeat="400"
                                        style={{ backgroundImage: "url(" + IconColth2 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="2">
                                        <span className='bottom-[-20px] absolute w-full text-center'>2</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-2"
                                        data-path="/cloth_fabric/3-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconColth3 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="3">
                                        <span className='bottom-[-20px] absolute w-full text-center'>3</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-3"
                                        data-path="/cloth_fabric/4-normal.jpg"
                                        data-repeat="200" data-opacity="1"
                                        style={{ backgroundImage: "url(" + IconColth4 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="4">
                                        <span className='bottom-[-20px] absolute w-full text-center'>4</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-4"
                                        data-path="/cloth_fabric/5-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconColth5 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="5">
                                        <span className='bottom-[-20px] absolute w-full text-center'>5</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-5"
                                        data-path="/cloth_fabric/6-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconColth6 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="6">
                                        <span className='bottom-[-20px] absolute w-full text-center'>6</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-6"
                                        data-path="/cloth_fabric/7-normal.jpg"
                                        data-repeat="200"
                                        data-opacity="1"
                                        style={{ backgroundImage: "url(" + IconColth7 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="7">
                                        <span className='bottom-[-20px] absolute w-full text-center'>7</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-7"
                                        data-path="/cloth_fabric/8-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconColth8 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="8">
                                        <span className='bottom-[-20px] absolute w-full text-center'>8</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-8"
                                        data-path="/cloth_fabric/9-normal.jpg"
                                        data-repeat="200"
                                        style={{ backgroundImage: "url(" + IconColth9 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="9">
                                        <span className='bottom-[-20px] absolute w-full text-center'>9</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-9"
                                        data-path="/cloth_fabric/10-normal.jpg"
                                        data-repeat="100"
                                        style={{ backgroundImage: "url(" + IconColth10 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2
                                         border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="10">
                                        <span className='bottom-[-20px] absolute w-full text-center'>10</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-10"
                                        data-path="/cloth_fabric/11-normal.jpg"
                                        data-repeat="50"
                                        style={{ backgroundImage: "url(" + IconColth11 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="11">
                                        <span className='bottom-[-20px] absolute w-full text-center'>11</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-11"
                                        data-path="/cloth_fabric/12-normal.jpg"
                                        data-repeat="25"
                                        style={{ backgroundImage: "url(" + IconColth12 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="12">
                                        <span className='bottom-[-20px] absolute w-full text-center'>12</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-12"
                                        data-path="/cloth_fabric/13-normal.jpg"
                                        data-repeat="200" data-opacity="1"
                                        style={{ backgroundImage: "url(" + IconColth13 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="13">
                                        <span className='bottom-[-20px] absolute w-full text-center'>13</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-13"
                                        data-path="/cloth_fabric/14-normal.jpg"
                                        data-repeat="600"
                                        style={{ backgroundImage: "url(" + IconColth14 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="14">
                                        <span className='bottom-[-20px] absolute w-full text-center'>14</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                    <div
                                        id="tecido-14"
                                        data-path="/cloth_fabric/15-normal.jpg"
                                        data-repeat="400"
                                        style={{ backgroundImage: "url(" + IconColth15 + ")" }}
                                        className="tecido aspect-square rounded-lg bg-cover bg-center cursor-pointer border-2 
                                        border-transparent hover:border-primary transition-all hover:scale-105 shadow-sm"
                                        data-nam="15">
                                        <span className='bottom-[-20px] absolute w-full text-center'>15</span>
                                        <div className='tecido2 absolute inset-0 rounded-lg'></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabsContent>
                    <TabsContent value="fabric" id="" className='custom space-y-4'>
                    </TabsContent>
                </ShadcnTabs>
            </CardContent>
        </Card>
    )
}

export default Cloth